import { Plugin } from '@nuxt/types'

const gtm: Plugin = ({ app: { $gtm, $env } }) => {
  setTimeout(() => $gtm?.init($env!.gtmId))
}

export default gtm
